import { useDataSourceMetaWithLoading } from 'platform-dashboard-ui/hooks/use-data-source-metadata';
import { useDataSourceProperties } from 'platform-dashboard-ui/hooks/use-data-source-properties';
import { getDashboardDataSources } from 'platform-dashboard-ui/lib/dashboardDataSourceUtils';
import { useSavedDashboardFiltersPanelContext } from '../context';
import { getDataSourceKeysForFilters } from '../../../../../../ducks/applied-dashboard-filters/utils';
const useDataSources = dataSourceKeys => {
  const {
    isLoading: isDataSourcesMetadataLoading,
    dataSourceMetaData
  } = useDataSourceMetaWithLoading(dataSourceKeys);
  const {
    isLoading: isDataSourcesPropertiesLoading,
    propertiesByDataSource
  } = useDataSourceProperties(dataSourceKeys);
  const isLoading = isDataSourcesMetadataLoading || isDataSourcesPropertiesLoading;
  return {
    dataSourceKeys,
    dataSourcesMetadata: dataSourceMetaData,
    dataSourcesProperties: propertiesByDataSource,
    isLoading
  };
};
export const useReportDataSources = () => {
  const {
    dashboard
  } = useSavedDashboardFiltersPanelContext();
  const dashboardDataSources = getDashboardDataSources(dashboard);
  const dataSourceKeys = new Set(dashboardDataSources);
  return useDataSources(Array.from(dataSourceKeys));
};
export const useFiltersDataSources = filters => {
  return useDataSources(getDataSourceKeysForFilters(filters));
};